import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AuthService } from '@auth0/auth0-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/shared/helper/util.service';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { environment } from 'src/environments/environment';
import { DataProductsService } from '../data-products.service';
import moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-my-reports',
  templateUrl: './my-reports.component.html',
  styleUrl: './my-reports.component.scss'
})
export class MyReportsComponent implements OnInit {

  isFilterOpen = true;
  isRequestExpanded: any | null = null;
  selectedItems: any[] = []; 
  isFilterOptionOpen: boolean = false;
  typeFilterDropdownSettings: IDropdownSettings = {};
  isShowNewRequest: boolean;
  modulesResult: any=[];
  noSubscriptionsFlag=true;
  isNotificationTextVisible: boolean;
  showCounting: boolean;
  getAuthStatus: boolean;
  dataRequestForm: FormGroup;
  period: any;
  periodForValue: any;
  searchValue: any = '';
  id: string = '';
  moduleByteMap: { [key: string]: any } = {};
  files: any;
  fileData: any;
  filterData: any;
  totalItems: any;
  isLoadData: boolean;
  statusTiles: any;
  statusTileData: any;
  statusTilesData: any[]=[];
  capabilitiesModule: any;
  p: number = 1;
  moduleIds: any = [];
  selectedModuleName: any;
  tileNameValue: any;
  selectedTileIndex: number;
  statusIds: any = [];
  selectedFilterType: any = [];
  selectedRowId: any;
  getDownloadProductType: any;
  errorFlag: boolean;
  showErrorMessage: boolean;
  fillErrorText: any;
  errMsgText: any;
  sortByValue: string = '';
  sortTypeValue: string = 'desc';
  sortColumn: string = '';
  isAdvancedFilter: boolean;
  isFilterRecords: boolean;
  userId: any;
  successMessage: any;
  errMsg: any;
  showErrorMessageWithPopup: boolean;
  getCapabilitiesModulesForLink: any;
 readonly fixedDate='09/15/2024'
  getRequestId: any;
  downloadFileLabel: any;
  requestCompletedDate: any;
  isDownloadPopupVisibale: boolean;
  getModuleIdForDownload: any;
  downloadFileName: any;
  isDownloadPopupVisible: boolean;
  isOpenOverlayScreen: boolean = false;
  flagError: boolean;
  startDate: Date | null = null;
  endDate: Date | null = null;
  maxDate: Date = new Date();
  createdOn = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });
  modifiedOn = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });
  dateType: any = 'created';
  statusFilterDropdownSettings: IDropdownSettings = {};
  statusType: string;
  selectedStatusType: any = [];
  capabilitiesData: any;
  capabilitiesModuleRecords: any[];
   clearSubscription: Subscription;
  errMsgPopup: any;
  downloadUrl: string;
  displayStyle: string;
  isShowAdvanceFilter: boolean;
  bgColorStatus: boolean;
  isResetButtonVisible: boolean;
  loginAlertMessage: string ='To unlock this Features, please login with your credentials';
  storeRequestId: string;
  activeSortIndex:any= null;
  isAscending: boolean = true;
  statusList: any=[];
  statusNames: any;
  isLoading: boolean = true;
  constructor(
    private spinnerService: NgxSpinnerService,
    private utilService: UtilService,
    private fb: FormBuilder,
    private http: HttpClient,
    public auth: AuthService,
    private homePageService: HomePageService,
    private dataProductService: DataProductsService,
    public router: Router,
    public elementRef: ElementRef 
  ) {
    this.utilService.goToTop();
  }
  ngOnInit(): void {
    // Initialization logic here
     this.setCreatedDateValidation();
     this.setUpdatedDateValidation();
    this.utilService.moduleBytes.subscribe((mod) => {
      this.moduleByteMap = mod as Object;
    });
    this.utilService.getUserId.subscribe((id: any) => {
      if(id != 'undefined' && id != ''){
        this.id = id as string;
        this.loadAssignCapabilities();
      //  this.onInitialDataLoad();
       
      }
    });

    if (localStorage != null && localStorage.getItem('userId') != 'undefined') {
      this.id = localStorage.getItem('userId');
    }
     this.buildForm();
     this.getStatus();
   
    // Type filetr API call
    // if (localStorage.getItem('userId')) {
    //   this.loadAssignCapabilities();
    // }  
    //   if (!localStorage.getItem('token')) {
    //   this.isNotificationTextVisible = true;
    //   this.showCounting = false;
    // } else {
    //   this.showCounting = true;
    //   this.isNotificationTextVisible = false;
    // }
    this.typeFilterDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'moduleName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };

      // status search setting
    this.statusFilterDropdownSettings = {
      singleSelection: false,
      idField: 'statusId',
      textField: 'statusName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
 //getting errors block
    this.clearSubscription = this.utilService.SharingDataPopUpMessage.subscribe(
      (res: any) => {
        this.spinnerService.hide();        
        this.errMsgPopup = res;
      }
    );
    this.clearSubscription = this.utilService.getPopupStatus.subscribe(
      (res: any) => {
        this.spinnerService.hide();
        this.showErrorMessageWithPopup = res;
      }
    );
    this.clearSubscription = this.utilService.SharingDataTextMessage.subscribe(
      (res: any) => {
        this.spinnerService.hide();
        this.errMsgText = res;
        if (this.flagError) {
          this.flagError = true;
        } else {
          this.flagError = false;
        }
        setTimeout(() => {
          this.errMsgText = null;
          this.flagError = false;
        }, 3000);
      }
    );
    this.clearSubscription = this.utilService.errorTextBlock.subscribe(
      (res: any) => {
      if(res) this.isLoading = false;
       this.spinnerService.hide();
       this.showErrorMessage = res;
      }
    );
  }


////
 onInitialDataLoad() {
    this.getRequestList();
}
getRequestList(){
  this.spinnerService.show();
  this.isLoading = true;
  this.dataProductService.getRequestList(this.id,this.itemsPerPage,this.p).subscribe((res: any) => {
        this.files = res.result;
        this.fileData = this.files[0].results;
        this.filterData = [...this.fileData];
        if (this.filterData?.length > 0) {
          this.setActionRules(res)
        }
        this.totalItems = this.files[0].totalRows;
        this.isLoadData = true;
        this.statusTiles = res.result;
        this.statusTileData = this.statusTiles[0].statusSummery;
        this.statusTilesData = [...this.statusTileData];
        this.statusList = res.result[0].statusSummery;
        this.isLoadData = true;
        this.spinnerService.hide();
        this.isLoading = false;
        this.dataProductService.headerSubject.next(true);
      });
}

setActionRules(res:any){
  this.filterData?.forEach((item:any)=>{
    let modules=this.capabilitiesModule?.result?.find((x:any)=>x?.headerLabel=='Data Products')?.modules;
    modules = this.modulesResult;
    let module=null
    
    if(modules?.length>0){
      module=modules.find((ele:any)=>ele.moduleName==item.productType);
        item.createAction= module.createAction;
        item.deleteAction= module.deleteAction;
        item.downloadAction= module.downloadAction;
        item.editAction= module.editAction;
        item.rerunAction= module.rerunAction;
        item.copyAction= module.copyAction;
        item.subscription= module.subscription;
    }
  })

}

buildForm() {
      this.dataRequestForm = this.fb.group({
        searchText: new FormControl(''),
        type: new FormControl([]),
        createdOn: this.createdOn,
        modifiedOn: this.modifiedOn,
        statusType: new FormControl([]), 
      });
}

   onAdvancedFilter() {
    this.isAdvancedFilter = true;
    this.isFilterRecords = false;
  //  this.spinnerService.show();
    if (this.dataRequestForm.get('searchText')?.value === null) {
      this.dataRequestForm.get('searchText')?.setValue('');
    }
    const filterValues = {
      platformUserId: this.id.toString(),
      moduleId: this.moduleIds,
      statusId: this.statusIds,
      createdOn: {
        startDate: this.createdOn.get('startDate')?.value ? formatDate(this.createdOn.get('startDate')?.value, 'yyyy-MM-dd', 'en-US') : null,
        endDate: this.createdOn.get('endDate')?.value ? formatDate(this.createdOn.get('endDate')?.value, 'yyyy-MM-dd', 'en-US') : null
      },
      modifiedOn: {
        startDate: this.modifiedOn.get('startDate')?.value ? formatDate(this.modifiedOn.get('startDate')?.value, 'yyyy-MM-dd', 'en-US') : null,
        endDate: this.modifiedOn.get('endDate')?.value ? formatDate(this.modifiedOn.get('endDate')?.value, 'yyyy-MM-dd', 'en-US') : null
      },
      searchText: this.dataRequestForm.get('searchText')?.value,
      sortBy: this.sortByValue,
      sortType: this.sortTypeValue,
    };
    this.p = 1;
 
    this.dataProductService.onRequestDetailsFilter(filterValues).subscribe({
      next: (res: any) => {
        // load tiles data
        // Update status count in existing statusTilesData instead of replacing the array
        const apiStatusSummary = res.result[0]?.statusSummery || [];
        if (Array.isArray(this.statusTilesData) && this.statusTilesData.length > 0) {
          this.statusTilesData.forEach(tile => {
            const apiTile = apiStatusSummary.find((s: any) => s.statusId === tile.statusId);
            if (apiTile) {
              tile.statusCount = apiTile.statusCount;
            }else{
              tile.statusCount = 0;
            }
          });
        } else {
          // If statusTilesData is empty, initialize it
          this.statusTilesData = [...apiStatusSummary];
        }
        this.statusTiles = res.result;
        this.statusTileData = this.statusTiles[0].statusSummery;
        // Do not replace this.statusTilesData here
        // filter data load
        this.spinnerService.hide();
        this.files = res.result;
        this.fileData = this.files[0].results;
        this.filterData = [...this.fileData];
        this.setActionRules(res);
        this.totalItems = this.files[0].totalRows;
        this.isLoadData = true;
        this.errorFlag = false;
      },
      error: (err: any) => {
        this.spinnerService.hide();
        this.errorFlag = true;
        this.showErrorMessage = true;
        this.fillErrorText = this.errMsgText;
      },
    });
  }
 
  onSelectAllTypes(items: any) {
    if (this.getAuthStatus) {
      this.dataRequestForm.get('type')?.setValue(items);
      this.moduleIds = items.map((x: any) => x.id);
      this.onAdvancedFilter();
  }
  }
   onSelectAllStatusTypes(items: any) {
    if (this.getAuthStatus) {
      const control = this.dataRequestForm.get('statusType') as FormControl;
      control.setValue(items);  
      this.statusIds = items.map((item:any) => item.statusId);
      this.onAdvancedFilter();
    }
  }
  getUpdatedTiles() {
    for (let data of this.statusTileData) {
      data.statusId = this.getCount(data.statusName);
    }    
  }
   getCount(character: any) {
    return this.filterData.filter((obj: any) => obj.statusName === character)
      .length;
  }

  onDeSelectAllTypes() {
    if (this.getAuthStatus) {
      this.dataRequestForm.get('type')?.setValue([]);
      this.moduleIds = [];
      this.onAdvancedFilter();
    }
  }
  onDeSelectAllStatusTypes() {
    if (this.getAuthStatus) {
      const control = this.dataRequestForm.get('statusType') as FormControl;
      control.setValue([]);  // Clear all
      this.statusIds = [];
      this.onAdvancedFilter();
    }
  }
  // onTileSelect(index: any, tName: any, indexTile: number) {
  //   this.tileNameValue = tName;
  //   this.selectedTileIndex = indexTile;
  //   this.statusIds = [];
  //   this.statusIds.push(index);
  //   if (
  //     localStorage.getItem('token') &&
  //     localStorage.getItem('id') !== undefined
  //   ) {
  //     this.selectedTileIndex=0;
  //     this.onAdvancedFilter();
  //   }
  // }
  onTypeSelect(item: any) {
    if (this.getAuthStatus) {
      const selected = this.dataRequestForm.get('type')?.value || [];
      this.moduleIds = selected.map((x: any) => x.id);  // or just use selected if it's IDs
      this.onAdvancedFilter();
  }
  }
 
  onTypeDeselect(item: any) {
 if (this.getAuthStatus) {
    const selected = this.dataRequestForm.get('type')?.value || [];
    this.moduleIds = selected.map((x: any) => x.id);
    this.onAdvancedFilter();
  }
}

onStatusSelect(item: any) {
  if (this.getAuthStatus) {
    const control = this.dataRequestForm.get('statusType') as FormControl;
    const current = control.value || [];
    if (!current.find((i: any) => i.statusId === item.statusId)) {
      control.setValue([...current, item]);
    }
    this.statusIds = control.value.map((i: any) => i.statusId);
    this.onAdvancedFilter();
  }
}
 
  onStatusDeselect(item: any) {
  if (this.getAuthStatus) {
    const control = this.dataRequestForm.get('statusType') as FormControl;
    const newValue = (control.value || []).filter((i: any) => i.statusId !== item.statusId);
    control.setValue(newValue);
    this.statusIds = newValue.map((i: any) => i.statusId);
    this.onAdvancedFilter();
  }
}
getStatus() {
    if (
      localStorage.getItem('token') &&
      localStorage.getItem('id') !== undefined
    ) {
      this.getAuthStatus = true;
    }
  }
  onCreateNewRequest() {
    this.isShowNewRequest = true;
    this.loadAssignCapabilities();
  }
  loadAssignCapabilities() {
    this.homePageService.onHeader(this.id).subscribe((res) => {
      const capabilitiesModules = this.getCapabilitiesModules(res.result);
      const subsModules = this.getSubscribedModules(capabilitiesModules);
      this.modulesResult = subsModules;
      this.getCapabilitiesModulesForLink =  this.modulesResult;
      if(this.modulesResult.length==0){
        this.noSubscriptionsFlag=true;
      }else{
        this.noSubscriptionsFlag=false;
      }
       this.onInitialDataLoad();
    });
  }
  
  private getCapabilitiesModules(results: any[]): any[] {
    for (const result of results) {
      if (result.headerName === 'Data Products') {
        return result.modules;
      }
    }
    return [];
  }
   private getSubscribedModules(modules: any[]): any[] {
    return modules.filter((module) => module.subscription === true);
  }
  @Output() selectionChange = new EventEmitter<string[]>();

  toggleFiltersCont() : void {
    this.isFilterOpen = !this.isFilterOpen;
  }
@HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.isRequestExpanded !== null &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.isRequestExpanded = null;
    }
  }
  showReqOptions(index:any,product: any) {
    this.isRequestExpanded = this.isRequestExpanded === product.requestId ? null : product.requestId;
   this.getDownloadProductType = product.productType;
    if (this.selectedRowId === index) {
      this.selectedRowId = null;
    } else {
      this.selectedRowId = index;
    }
  }

  showOptions() {
     this.isFilterOptionOpen = !this.isFilterOptionOpen 
  }
  //// Pagination for table starts

  currentPage = 1;
  itemsPerPage: number = 10;
  loadedItemsCount = 8
 // searchTerm = ''
  isSelected(optionId: any): boolean {
    return this.selectedItems.includes(optionId);
  }

  toggleSelection(optionId: any) {
    if (!this.isSelected(optionId)) {
      this.selectedItems = [optionId];
    } else {
      this.selectedItems = [];
    }
    this.selectionChange.emit(this.selectedItems);
  }

  clearSelection() {
    this.selectedItems = [];
    this.selectionChange.emit(this.selectedItems);
    this.isRequestExpanded = null;
  }

  showDeletepopup = false
  showNewRequestsPopup = false

  onDelete(type: string, requestId: any) {
    this.showDeletepopup = !this.showDeletepopup;
     this.storeRequestId = requestId;
  }
 onClosePopup() {
    this.showDeletepopup = false;
    this.storeRequestId = '';
  }
  newReq() {
    this.showNewRequestsPopup = !this.showNewRequestsPopup;
    this.loadAssignCapabilities();
  }
  goToLink(moduleLink: string) {
    const token = localStorage.getItem('token');
    window.open(`${moduleLink}?token=${token}`, '_blank');
  }
    getPage(event: any) {
      this.spinnerService.show();
      this.p = event;
      this.currentPage = this.p - 1;
      const userId: any = this.id.toString();
      let headers = new HttpHeaders().append('userId', userId);
      const requestOptions = { headers: headers };
      if (!this.isFilterRecords && !this.isAdvancedFilter) {
        this.http
          .post(
            `${environment.apiUrl}/v1/requests?limit=${this.itemsPerPage}&page=${this.p}`,
            null,
            requestOptions
          )
          .subscribe((res: any) => {
            this.spinnerService.hide();
            this.files = res.result;
            this.fileData = this.files[0].results;
            this.filterData = [...this.fileData];
  
            this.setActionRules(res)
            this.totalItems = this.files[0].totalRows;
            this.isLoadData = true;
          });
      } else if (this.isFilterRecords && this.isAdvancedFilter == false) {
        const userIdValue: any = this.id.toString();
        let headersValue = new HttpHeaders().append('userId', userIdValue);
        const requestOptionsValue = { headers: headersValue };
        
        this.http
          .post(
            `${environment.apiUrl}/v1/requestDetailsBySearch?limit=${this.itemsPerPage}&page=${this.p}&searchText=${this.dataRequestForm.get('searchText')}`,
            null,
            requestOptionsValue
          )
          .subscribe({
            next: (res: any) => {
              this.spinnerService.hide();
              this.files = res.result;
              this.fileData = this.files[0].results;
              this.filterData = [...this.fileData];
              this.setActionRules(res)
              this.totalItems = this.files[0].totalRows;
              this.isLoadData = true;
              this.errorFlag = false;
            },
            error: (err: any) => {
              this.spinnerService.hide();
              this.errorFlag = true;
              this.showErrorMessage = true;
              this.fillErrorText = this.errMsgText;
            },
          });
      } else if (this.isAdvancedFilter && this.isFilterRecords == false) {
        const filterValues = {
          platformUserId: this.id.toString(),
          moduleId: this.moduleIds,
          statusId: this.statusIds,
          // periodFor: this.periodForValue,
          // period: this.period,
          createdOn: {
            startDate: this.createdOn.get('startDate')?.value ? formatDate(this.createdOn.get('startDate')?.value, 'yyyy-MM-dd', 'en-US') : null,
            endDate: this.createdOn.get('endDate')?.value ? formatDate(this.createdOn.get('endDate')?.value, 'yyyy-MM-dd', 'en-US') : null
          },
          modifiedOn: {
            startDate: this.modifiedOn.get('startDate')?.value ? formatDate(this.modifiedOn.get('startDate')?.value, 'yyyy-MM-dd', 'en-US') : null,
            endDate: this.modifiedOn.get('endDate')?.value ? formatDate(this.modifiedOn.get('endDate')?.value, 'yyyy-MM-dd', 'en-US') : null
          },
          searchText: this.dataRequestForm.get('searchText')?.value,
          sortBy: this.sortByValue,
          sortType: this.sortTypeValue,
        };
        this.http
          .post(
            `${environment.apiUrl}/v1/requestDetailsFilter?limit=${this.itemsPerPage}&page=${this.p}`,
            filterValues
          )
          .subscribe({
            next: (res: any) => {
              this.spinnerService.hide();
              this.files = res.result;
              this.fileData = this.files[0].results;
              this.filterData = [...this.fileData];
              this.setActionRules(res)
              this.totalItems = this.files[0].totalRows;
              this.isLoadData = true;
              this.errorFlag = false;
            },
            error: (err: any) => {
              this.spinnerService.hide();
              this.errorFlag = true;
              this.showErrorMessage = true;
              this.fillErrorText = this.errMsgText;
            },
          });
      }
    }
     getSearchText(e: any) {
    this.dataRequestForm.get('searchText')?.setValue(e.target.value);
    if (
      localStorage.getItem('token') &&
      localStorage.getItem('id') !== undefined
    ) {
      this.onAdvancedFilter();
    } else {
      this.filterTable();
      this.getUpdatedTiles();
    }
  }
    filterTable() {
    this.filterData = this.filterData.filter(
      (item: any) =>
        item.requestId.toLowerCase().includes(this.dataRequestForm.get('searchText')?.value.toLowerCase()) ||
        item.productType
          .toLowerCase()
          .includes(this.dataRequestForm.get('searchText')?.value.toLowerCase()) ||
        item.labelName.toLowerCase().includes(this.dataRequestForm.get('searchText')?.value.toLowerCase())
    );
  }
  togglePinned(request:any): void {
    request.isPinned = !request.isPinned;
    let reqBody = {
        "userId": this.id,
        "requestId": request.requestId,
        "isPinned": request.isPinned
    }
    this.markUnmarkPinned(reqBody);
  }
  markUnmarkPinned(reqBody:any){
    this.dataProductService.markUnmarkPinned(reqBody).subscribe((response: any) => {      
      if(response.code == 200){
        this.successMessage = response.result;
        this.onAdvancedFilter();
        setTimeout(() => { this.successMessage = false; this.successMessage = ''; }, 3000)
      }
    })
  }

 onCloseHandler() {
    if (this.errMsg &&this.errMsg.includes('Session Expired')) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    }else{
      this.errMsg = null;
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }


onMenuClick(item: any, option: any){
  switch(option.actionName) {
    case 'Download':
      this.openPopup(item.statusName === 'COMPLETED',item.requestId,item.labelName,item.outputFiles,item.moduleId,item.requestCompletedDate);
      break;
    case 'Re-run':
      this.onRerun(item, item.requestId);
      break;
    case 'Edit':
      this.onEdit(item.productType, item.requestId);
      break;
    case 'Delete':
      this.onDelete(item,item.requestId);
      break;
    case 'Copy':
      this.onCopy(item.productType, item.requestId);
      break;
  }
}


  onEdit(type: string, requestId: any) {
    const rId = requestId;
    const dynamicDraftId = rId.split('-')[1];      
    for (let i = 0; i < this.getCapabilitiesModulesForLink.length; i++) {
      if (type === this.getCapabilitiesModulesForLink[i].moduleName) {
        const token = localStorage.getItem('token');
        const url = this.getCapabilitiesModulesForLink[i].moduleLink;
      //  const url="http://localhost:60523";
        let dynamicPathValue = 'jobrequest';                                    
        window.open(`${url}/${dynamicPathValue}/${dynamicDraftId}?token=${token}`, '_blank');
      }
    }
  }
  
  onRerun(item: any, requestId: any){  
       this.dataProductService.reRunRequest(requestId).subscribe({  
        next: (res: any) => {
          this.spinnerService.hide();
          if (res.code !== 200) {
            const errorResult = res.result;
            this.errMsgText = errorResult.message;
            this.resetAllFilters();
            setTimeout(() => {
              this.errMsgText = null;              
            }, 3000);
          } else {
            const response = res;
            this.successMessage = response.result.message; 
            this.utilService.goToTop(); 
            this.p=1; 
            this.resetAllFilters();
            setTimeout(() => {
              this.successMessage = null;                                     
            }, 3000);
          }
        },
        error: (err) => {                                                                       
          this.spinnerService.hide();
        },                                                      
       });
  }

  onCopy(type: string, requestId: any) {
    const rId = requestId;
    const dynamicDraftId = rId.split('-')[1];      
    for (let i = 0; i <= this.getCapabilitiesModulesForLink.length; i++) {
      if (type === this.getCapabilitiesModulesForLink[i].moduleName) {
        const token = localStorage.getItem('token');
        const url = this.getCapabilitiesModulesForLink[i].moduleLink;
      //  const url="http://localhost:60523";
        let dynamicPathValue = 'copyrequest';                                    
        window.open(`${url}/${dynamicPathValue}/${dynamicDraftId}?token=${token}`, '_blank');
      }
    }
  }

openPopup(
    status: any,
    requestId: any,
    itemLabel: any,
    itemFileName: any,
    moduleId: any,
    requestCompletedDate: any
  ) {
    this.getModuleIdForDownload = moduleId;
    if (status == true) {
      this.getRequestId = requestId;
      this.downloadFileLabel = itemLabel;
      this.downloadFileName = itemFileName;
      this.requestCompletedDate = requestCompletedDate;
      this.displayStyle = 'block';
      this.isDownloadPopupVisibale = true;
    } else if (status == false) {
      this.displayStyle = 'none';
      this.isDownloadPopupVisibale = false;
    }
  }
  closePopup() {
    this.displayStyle = 'none';
    this.isDownloadPopupVisibale = false;
    this.getDownloadProductType = '';
  }
  closeOverlayPopup() {
    this.isShowAdvanceFilter = false;
    this.isOpenOverlayScreen = false;
    this.dataRequestForm.get('search')?.enable();
    this.bgColorStatus = false;
    this.isResetButtonVisible = true;
  }

  onDownload(downloadFileName: any) {
    if (!localStorage.getItem('token')) {
      this.isOpenOverlayScreen = true;
      return;
    }
    this.spinnerService.show();

    const downloadBody = {
      userId: this.id.toString(),
      fileName: downloadFileName,
      capability: this.getDownloadProductType,
      cluster: 'Dmint-Platform',
    };

    this.dataProductService.onDownloadCall(downloadBody, this.id).subscribe({
      next: (response: any) => {
        this.spinnerService.hide();
        const result = response.result;
        const trimResult = result.slice(0, -4);
        this.downloadUrl = atob(trimResult);
        this.sendFileToDownload(this.downloadUrl);
      },
      error: (err) => {
        this.spinnerService.hide();
      },
    });
  }

  sendFileToDownload(url: string) {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = url.split('/').pop() || 'download';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
 onDeleteRequest(requestId: string) {
    if (!localStorage.getItem('token')||!this.id) {
      this.isOpenOverlayScreen = true;
      return;
    }
    this.spinnerService.show();
    this.dataProductService.onDeleteRequestCall(this.id, requestId).subscribe({
      next: (res: any) => {
        this.spinnerService.hide();
        this.successMessage = res.result;
        this.isDownloadPopupVisible = false;
        this.isOpenOverlayScreen = false;
        this.flagError = false;
        this.showDeletepopup = !this.showDeletepopup;
        //this.tilesCalled();
        this.resetAllFilters();
        setTimeout(() => {
          this.successMessage = null;
        }, 3000);
      },
      error: (err) => {
        this.flagError = true;
      },
    });
  }
 


  setCreatedDateValidation(){
     this.createdOn.setValidators((group: any) => {
      const start = group.get('startDate')?.value;
      const end = group.get('endDate')?.value;
      if (start && end) {
        if (end < start) {
          return { endBeforeStart: true };
        }
 }
    return null;
  });
  }
   setUpdatedDateValidation(){
     this.modifiedOn.setValidators((group: any) => {
      const start = group.get('startDate')?.value;
      const end = group.get('endDate')?.value;
      if (start && end) {
        if (end < start) {
          return { endBeforeStart: true };
        }
      }
    return null;
  });
  }
onDateSelected(dateType:any,event:any) {
  this.onAdvancedFilter();
}

  resetAllFilters() {
    this.isAdvancedFilter = false;
    this.isFilterRecords = false;
    this.dataRequestForm.get('searchText')?.reset();
    this.searchValue = '';
    this.dataRequestForm.patchValue({
      searchText: '',
    });
    this.dataRequestForm.get('type')?.setValue([]);
    this.dataRequestForm.get('statusType')?.setValue([]);

    this.createdOn.reset();
    this.modifiedOn.reset();
    this.createdOn.get('startDate')?.setValue(null);
    this.createdOn.get('endDate')?.setValue(null);
    this.modifiedOn.get('startDate')?.setValue(null);
    this.modifiedOn.get('endDate')?.setValue(null);
    this.selectedFilterType = [];
    this.moduleIds = [];
    this.statusIds = [];
    this.errorFlag = false;
    this.isAscending = true;
    this.activeSortIndex = null;
    this.sortByValue = '';
    this.sortTypeValue = '';
    this.selectedModuleName = [];
    this.selectedTileIndex = null;
    this.p = 1;
    this.onInitialDataLoad();
    
  }
  onSignIn() {
    this.utilService.onSignIn();
  }

  getSelectedFilterCount(): number {
    let count = 0;

    // Request Type filter
    const typeArray = this.dataRequestForm.get('type').value;
    if (typeArray && typeArray.length > 0) {
      count++;
    }

    // Created Date filter
    const createdStart = this.createdOn.get('startDate')?.value;
    const createdEnd = this.createdOn.get('endDate')?.value;
    if (createdStart || createdEnd) {
      count++;
    }

    // Modified Date filter
    const modifiedStart = this.modifiedOn.get('startDate')?.value;
    const modifiedEnd = this.modifiedOn.get('endDate')?.value;
    if (modifiedStart || modifiedEnd) {
      count++;
    }

    // Status filter
    const statusArray = this.dataRequestForm.get('statusType')?.value;
    if (statusArray && statusArray.length > 0) {
      count++;
    }

    // Search filter
    const searchText = this.dataRequestForm.get('searchText')?.value;
    if (searchText && searchText.trim().length > 0) {
      count++;
    }

    return count;
  }

onSort(column: string,i:any) {
    if(column ==='Created On'){
      this.sortByValue = 'request_created_date';
    }else {
      this.sortByValue = 'request_completed_date';
    }
     this.activeSortIndex = i;
     if (this.isAscending === true) {
        this.sortTypeValue = 'desc';
      } else {
        this.sortTypeValue = 'asc';
      }
    this.isAscending = !this.isAscending;
    this.onAdvancedFilter();
  }




ngOnDestroy(): void {
  this.clearSubscription.unsubscribe();
}

getActionIcon(actionName: string): string | null {
  switch (actionName) {
    case 'Download': return '/assets/images/download.svg';
    case 'Edit': return '/assets/images/edit-icon.svg';
    case 'Re-run': return '/assets/images/rerun.svg';
    case 'Copy': return '/assets/images/copyIcon.svg';
    case 'Delete': return '/assets/images/Trash.svg';
    default: return null;
  }
}
  reqOptions = [
    {
      id: 0,
      name: 'Download',
      iconSrc: '/assets/images/download.svg'
    },
    {
      id: 1,
      name: 'Edit',
      iconSrc: '/assets/images/edit-icon.svg'
    },
    {
      id: 2,
      name: 'Re-run',
      iconSrc: '/assets/images/rerun.svg'
    },
    {
      id: 3,
      name: 'Copy',
      iconSrc: '/assets/images/copyIcon.svg'
    },
    {
      id: 4,
      name: 'Delete',
      iconSrc: '/assets/images/Trash.svg'
    }
  ]


  drmTableHeaders = [
    {
      id: 0,
      column_name: ''
    },
    {
      id: 1,
      column_name: 'Request ID'
    },
    {
      id: 2,
      column_name: 'Type'
    },
    {
      id: 3,
      column_name: 'Label'
    },
    {
      id: 4,
      column_name: 'Created On'
    },
    {
      id: 5,
      column_name: 'Last Run On'
    },
    {
      id: 6,
      column_name: 'Status'
    },
    {
      id: 7,
      column_name: 'Actions'
    }
  ]
}
